import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Container, Spinner } from "react-bootstrap";
import { BfColInput } from '../../../Styling/FormComponents/FormInput'
import { BfButtonBlue, BfButtonBlueSecondary, ArticleAreaNySak } from '../../../Styling/styledForm/styledBlueForm'
import useDebitorFormWithAI from './useDebitorFormWithAI';
import { useNavigate } from 'react-router-dom';
import { ConfirmModal } from '../../../components/confirmModal/ConfirmModal';
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import DebitorResultForm from './DebitorResultForm';
import FakturaResultForm from './FakturaResultForm';
import CaseListToolTip from '../../caselist_redux/caseListTable/CaseListTooltip';
import { OverlaySpinner } from '../../../components/spinner/OverlaySpinner';
import { clearPdfInfo } from '../../../reduxStore/newCase/newCaseActions';
import { NotFinishedModal } from '../modals/NotFinishedModal';
import { DifferentDebitorModal } from '../modals/DifferentDebitorModal';
import { useDropzone } from 'react-dropzone';


const ColumnsWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: stretch;
`;

const LeftColumn = styled.div`
  width: ${({ $toggled }) => ($toggled ? '30%' : '50%')};
  padding-right: 0.5rem;
  position: relative;
  transition: width 0.3s ease-in-out;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    border-right: 1px solid #ccc;
  }

`;

const RightColumn = styled.div`
  width: ${({ $toggled }) => ($toggled ? '70%' : '50%')};
  padding-left: 3rem;
  transition: width 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  
  p {
    font-size: 0.9em;
    margin-bottom: 1rem;
    width: 80%;
  }
`;

const ToggleIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
  cursor: pointer;
  font-size: 20px;
  color: #333;
  transition: transform 0.3s ease-in-out;

  &:hover {
    color: #0078D4;
  }
`;

const FileContainer = styled.div`
  display: inline-flex; 
  align-items: center;
  background-color: #f7f7f7;
  border: 2px solid #ddd;
  border-radius: 0.5em;
  padding: 4px 12px 4px 12px;
  margin: 8px 0;
`;

const FileNameText = styled.span`
  flex: 1;
  font-size: 20px;
  font-weight: 400;
  font-family: "RM Neue", "sans-serif";
`;

const PlaceholderText = styled.span`
  font-size: 20px;
  font-weight: 400;
  font-family: "RM Neue", "sans-serif";
  color: black;
`;

const RemoveIcon = styled.span`
  font-size: 16px;
  color: grey;
  cursor: pointer;
  margin-left: 12px;
  &:hover {
    color: #333;
  }
`;

const DebitorFormWithAI = (props) => {

    const {
      formValues, formValidators, handleChange, formState, validateAll, setField,
      hasErrorsDebitor, hasErrorsFaktura, errorMessages, extraErrors, setExtraErrors,
      submitForm, finalizeFaktura, editFaktura, deleteFaktura, emptyForm, errorMessage, localeMessages, produktOptions, handlePnrChange,
      debtorTypeOptions, setFieldsFromPDF, currencyOptions, clearForm, notFinishedModal, differentDebitorModal,
      onPdfFakturaChange, filePdfFakturaRef, setSelectedPdfFaktura, setPdfUrl, pdfUrl, fileUploadRef, onUploadFileChange, selectedUploadFile, selectedPdfFaktura
    } = useDebitorFormWithAI(props.state, props.dispatch, props.showToasts, props.localeMessages )

    const navigate = useNavigate();
    const state = props.state;
    const invoices = state.invoices;
    const dispatch = useDispatch()
    const showToasts = true
    const [shrinkLeftColumn, setshrinkLeftColumn] = useState(false);

    useEffect(() => {
        return () => {
          if (state.pdfUrl || pdfUrl) {
            URL.revokeObjectURL(state.pdfUrl || pdfUrl);
          }
        };
      }, [state.pdfUrl, pdfUrl]);

    useEffect(() => {
          if (state.showReceiptAlert) {
            setPdfUrl(null);
            setSelectedPdfFaktura(null);
          }
    }, [state.showReceiptAlert]);

    useEffect(() => {
      if (state.clearPdf) {
        setPdfUrl(null);
        setSelectedPdfFaktura(null);
      }
    }, [state.clearPdf]);

    useEffect(() => {
      if (state.differentDebitor) {
        differentDebitorModal.showDialog();
      }
    }, [state.differentDebitor]);

    // Kall onPdfFakturaChange når pdf droppes
    const onDrop = useCallback(
      (acceptedFiles) => {
        if (acceptedFiles && acceptedFiles.length > 0) {
          const fakeEvent = { target: { files: acceptedFiles } };
          onPdfFakturaChange(fakeEvent);
        }
      },
      [onPdfFakturaChange]
    );
  
    // Dropzone skal kun godta PDF
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
      onDrop,
      accept: {
        'application/pdf': ['.pdf']
      }
    });

    const handleToggle = () => {
        setshrinkLeftColumn(prev => !prev);
    };

    const handleButtonClick = () => {
        if (filePdfFakturaRef.current) {
          filePdfFakturaRef.current.click();
        }
    };

    const handleBackClick = () => {
      if (invoices && invoices.length > 0) {
        notFinishedModal.showDialog();
      } else {
        dispatch(clearPdfInfo());
        navigate("/CaseNew/init");
      }
    };

    const FileItem = ({ filename, onRemove }) => {
      const veryLongFilename = filename.length > 25 ? filename.slice(0, 25) + '...' : filename;
      return (
        <FileContainer>
          <FileNameText title={filename}>{veryLongFilename}</FileNameText>
          <RemoveIcon onClick={onRemove} title='Fjern valgt PDF'>
            <i className="fa fa-times" aria-hidden="true" />
          </RemoveIcon>
        </FileContainer>
      );
    };

    const showDebitorResult = () => {
        return (
          <DebitorResultForm
            state={state}
            dispatch={dispatch}
            showToast={showToasts}
            localeMessages={localeMessages}
            disabled={false}
            formState={formState}
            handleChange={handleChange}
            hasErrorsDebitor={hasErrorsDebitor}
            errorMessages={errorMessages}
            extraErrors={extraErrors}
            produktOptions={produktOptions}
            debtorTypeOptions={debtorTypeOptions}
            handlePnrChange={handlePnrChange}
          />
        )
      }

      const showFakturaResult = () => {
        return (
          <FakturaResultForm
            state={state}
            dispatch={dispatch}
            showToast={showToasts}
            localeMessages={localeMessages}
            disabled={false}
            formState={formState}
            handleChange={handleChange}
            hasErrorsFaktura={hasErrorsFaktura}
            errorMessages={errorMessages}
            extraErrors={extraErrors}
            onUploadFileChange={onUploadFileChange}
            fileUploadRef={fileUploadRef}
            currencyOptions={currencyOptions}
            submitForm={submitForm}
            finalizeFaktura={finalizeFaktura}
            editFaktura={editFaktura}
            deleteFaktura={deleteFaktura}
            clearForm={clearForm}
            selectedUploadFile={selectedUploadFile}
          />
        )
      }

    return (
       <Container fluid="true">

            {state.pdfInfoError && (<Alert variant='danger'>{state.pdfInfoError}</Alert>)}
            {state.pdfInfoLoading && <OverlaySpinner text='Tolker faktura...'></OverlaySpinner>}
            {state.getPreCaseLoading && <OverlaySpinner text='Oppretter midlertidig sak..'></OverlaySpinner>}
            {state.pdfLoading && <OverlaySpinner></OverlaySpinner>}
            {state.showReceiptAlert && <Alert variant="info">
              {localeMessages.Receipt1}. {localeMessages.Receipt2a} <NavLink to="/Caselist">sakslisten</NavLink>{localeMessages.Receipt2b}</Alert>}
            {notFinishedModal.dialogVisible && <NotFinishedModal notFinishedModal={notFinishedModal} />}
            {(state.differentDebitor && differentDebitorModal.dialogVisible) && <DifferentDebitorModal differentDebitorModal={differentDebitorModal} />}

               <ColumnsWrapper>
                 <LeftColumn $toggled={shrinkLeftColumn}>
                    {state.pdfUrl && (
                        <CaseListToolTip caption={shrinkLeftColumn ? "Utvid venstre side" : "Reduser venstre side" }>
                            <ToggleIcon onClick={handleToggle}>
                                <i className={shrinkLeftColumn ? "fa fa-arrow-right" : "fa fa-arrow-left" }/>
                            </ToggleIcon>
                        </CaseListToolTip>
                    )}
                    <ArticleAreaNySak>
                      <h1>{localeMessages.uploadPDFHeader}</h1>
                      <p>{localeMessages.uploadPDFP}</p>
                    </ArticleAreaNySak>
                    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '12px'}}>
                      <BfButtonBlue variant="primary" onClick={handleButtonClick}>
                        {!pdfUrl ? localeMessages.uploadPDFButton : localeMessages.uploadNewPDFButton}
                      </BfButtonBlue>

                      <input
                        type="file"
                        ref={filePdfFakturaRef}
                        accept="application/pdf"
                        style={{ display: 'none' }}
                        onChange={onPdfFakturaChange}
                      />

                      <BfButtonBlueSecondary
                        variant="primary"
                        type="button"
                        onClick={handleBackClick}
                      >
                        {localeMessages.back}
                      </BfButtonBlueSecondary>

                      {selectedPdfFaktura && (
                        <FileItem
                          filename={selectedPdfFaktura[0].name}
                          onRemove={() => {
                            setPdfUrl(null);
                            setSelectedPdfFaktura(null);
                          }}
                        />
                      )}
                      </div>

                    {/* Viser PDF med engang den er valgt */}
                    {pdfUrl ? (
                      <div style={{ marginTop: '20px' }}>
                        <iframe
                          src={pdfUrl}
                          width="95%"
                          height="1200px"
                          title="PDF Preview"
                          style={{ border: 'none' }}
                        />
                      </div>
                    ) : (
                      // Placeholder for dropzone
                      <div
                        {...getRootProps()}
                        style={{
                          marginTop: '20px',
                          border: '2px dashed #ccc',
                          padding: '20px',
                          textAlign: 'center',
                          width: '95%',
                          height: '1200px'
                        }}
                      >
                        <input {...getInputProps()} />
                        {isDragActive ? (
                          <PlaceholderText>Helt supert, nå kan du slippe PDFen</PlaceholderText>
                        ) : (
                          <PlaceholderText>
                            Ingen PDF er valgt. Du kan dra og slippe en PDF her, trykke på dette feltet eller trykke på knappen over for å laste opp en.
                          </PlaceholderText>
                        )}
                      </div>
                    )}

                </LeftColumn>
                <RightColumn $toggled={shrinkLeftColumn}>
                    {!state.pdfUrl && (
                        <ArticleAreaNySak>
                            <h1>{localeMessages.resultHeader}</h1>
                            <p>{localeMessages.resultP}</p>
                        </ArticleAreaNySak>)}
                    {(state.pdfUrl && !state.loading) && (
                        showDebitorResult()
                    )}
                    {(state.pdfUrl && !state.loading) && (
                        showFakturaResult()
                    )}
                </RightColumn>
               </ColumnsWrapper>
             </Container>
    )
}

export default DebitorFormWithAI

